import React, { useCallback, useEffect, useState } from "react";
import { Topbar, LoginAlert, Alert } from "@components";
import {
	RootContainer,
	RefreshIcon,
	Text,
	Container,
	SpinWrapper,
	Title,
	Number,
	WinnersContainer,
	WinnerItem,
	PhNameWrapper,
	PhoneWrapper,
	NameWrapper,
	LeftSection,
	AmountWrapper,
	BottomContainer,
	ButtonWrapper,
	ButtonDiv,
	TableContainer,
	EmptyTextWrapper,
	StartButton,
	WinnerTitle,
} from "./SpinHome.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { Button, Spin, message } from "antd";
import SpinAlert from "./SpinAlert/SpinAlert";
import SpinWheel from "./SpinWheel/SpinWheel";
import { getFormattedNumber } from "@utils";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { SpinSound, CongratsSound, NoSpinWinnerIcon } from "@assets";
import { Howl } from "howler";
import CongratsModal from "./CongratsModal/CongratsModal";
import { localStorage } from '@utils';
import { SHARE_TYPES } from '@constants';
import { openAlert } from "../../../redux/app/appSlice";

const MaintainCard = ({ goBack }) => {
	const { t } = useTranslation();
	return (
		<Container>
			<Text>{t("spin.spinMaintainTitle")}</Text>
			<Text> {t("spin.spinMaintainSubtitle")}</Text>
			<Button type="primary" onClick={goBack}>
				{t("common.ok")}
			</Button>
		</Container>
	);
};

const Loader = () => {
	return (
		<SpinWrapper>
			<Spin />
		</SpinWrapper>
	);
};

const transformSpinValues = (spinValuesArray) => {
	return spinValuesArray.map((val) => ({
		option: `${String(val === "Thank you" ? val : getFormattedNumber(val))} ${val === "Thank you" ? "" : ""}`,
	}));
};

const _alert = {
	open: false,
	title: "",
	description: "",
	isError: false,
};

const SpinHome = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isLoggedIn = useSelector((state) => state.auth.token);
	const [loading, setLoading] = useState(true);
	const [isActive, setIsActive] = useState(true);
	const [spinValues, setSpinValues] = useState([]);
	const [winners, setWinners] = useState([]);
	const [rule, setRule] = useState("");
	const [started, setStarted] = useState(false);
	const [winningIndex, setWinningIndex] = useState(null);
	const [requesting, setRequesting] = useState(false);
	const [alert, setAlert] = useState(_alert);
	const [winningAmount, setWinningAmount] = useState(null);
	const [bonus_expired, setBonusExpired] = useState(null);
	const [congratsData, setCongratsData] = useState({
		open: false,
		winningAmount: 0,
		expired_on: "",
	});
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();
	const [can_share, setCanShare] = useState(0);
	const has_withdraw_account = useSelector(state => state.app.has_withdraw_account);

	const getSpinInfo = useCallback(() => {
		setLoading(true);
		api
			.getSpinInfo()
			.then(({ spin_values, spin_winners, spin_rule, is_spin_active }) => {
				setLoading(false);
				setSpinValues(transformSpinValues(spin_values));
				setWinners(spin_winners);
				// setWinners([])
				// setWinners([
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 1,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// 	{
				// 		user_id: "usr-00000-00000-00000-00000",
				// 		num: 2,
				// 		amount: 1000,
				// 		name: "Dummy Name",
				// 		phone: "********000",
				// 	},
				// ]);
				setRule(spin_rule);
				setIsActive(is_spin_active);
			})
			.catch((errorMsg) => {
				message.error(errorMsg);
			});
	}, []);

	useEffect(() => {
		getSpinInfo();
	}, [getSpinInfo]);

	const getWinningAmount = () => {
		setRequesting(true);
		api
			.getSpinReward()
			.then(({ amount, bonus_expired, can_share }) => {
				// setRequesting(false);
				setCanShare(can_share);
				const index =
					amount === 0
						? spinValues.findIndex((val) => val.option.includes("Thank you"))
						: spinValues.findIndex((val) => val.option === `${amount} `);
				setWinningIndex(index);
				setWinningAmount(amount);
				setBonusExpired(bonus_expired);
				setStarted(true);
				playSound();
			})
			.catch((errorMsg) => {
				setRequesting(false);
				setAlert({
					open: true,
					title: t("spin.spinWinningNotice"),
					description: errorMsg,
					isError: true,
				});
			});
	};

	useEffect(() => {
		// Create Howl instances for each sound effect
		const spinSoundEffect = new Howl({ src: [SpinSound] });

		// Clean up function
		return () => {
			// Unload and release the sound effects
			spinSoundEffect.unload();
		};
	}, []);

	const handleSpinClicked = (e) => {
		if (!isLoggedIn) {
			dispatch(setOpenLoginAlert(true));
			return;
		}
		if (!has_withdraw_account) {
			dispatch(
				openAlert({
					isError: true,
					message: t("common.withdrawAccountNeededErrorMsg"),
					successCallback: () => navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`, { state: { isSpin: 1 } }),
				})
			);
			return;
		}
		!requesting && getWinningAmount();
	};

	const handleStop = () => {
		setStarted(false);
		setRequesting(false);
		if (winningAmount !== null) {
			if (winningAmount > 0) {
				setCongratsData({
					open: true,
					winningAmount: getFormattedNumber(winningAmount),
					expired_on: bonus_expired,
				});
				playCongratsSound();
			} else {
				setAlert({
					open: true,
					title: t("spin.spinThankTitle"),
					description: t("spin.spinThankDescription"),
					isError: false,
				});
			}
		}
	};

	const goToShare = (is_spin_home) => {
		navigate(`/${PRIVATE_ROUTE.SHARE}`, {
			state: {
				share_type: SHARE_TYPES.SPIN,
				is_spin_home,
			},
		});
	}

	const onOk = () => {
		setAlert(_alert);
		if (can_share) {
			goToShare(1);
			return;
		}
		if (winningAmount > 0) {
			goToHistory();
		}
	};

	const handleOk = () => {
		if (can_share) {
			goToShare(0);
			return;
		}
		goToHistory();
	}

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const goToHistory = () => {
		if (!isLoggedIn) {
			dispatch(setOpenLoginAlert(true));
			return;
		}
		navigate(`/${PUBLIC_ROUTE.SPIN_HISTORY}`);
	};

	const goToRule = (state) => {
		navigate(`/${PUBLIC_ROUTE.SPIN_RULE}`, {
			state,
		});
	};

	const refresh = () => window.location.reload();

	const playSound = () => {
		new Howl({ src: [SpinSound] }).play();
	};

	const playCongratsSound = () => {
		new Howl({ src: [CongratsSound] }).play();
	};

	// const containerHeight = 100 + winners.length * 50 + 'px';

	return (
		<>
			<RootContainer>
				<Topbar
					title={t("spin.dailySpin")}
					transparent={true}
					fillOnScroll={false}
					rightIcon={<RefreshIcon onClick={refresh} />}
					goBack={goBack}
				/>
				{loading ? (
					<Loader />
				) : !isActive ? (
					<MaintainCard goBack={goBack} />
				) : (
					<>
						<SpinWheel
							handleSpinClicked={handleSpinClicked}
							started={started}
							winningIndex={winningIndex}
							spinValues={spinValues}
							handleStop={handleStop}
						/>

						<BottomContainer>
							<StartButton
								onClick={handleSpinClicked}
								type="default"
							>
								{t("spin.start")}
							</StartButton>
							<TableContainer>
								<WinnerTitle> {t('spin.dailyTopWinners')} </WinnerTitle>
								<WinnersContainer>
									{!loading && winners.length === 0 && (
										<EmptyTextWrapper>
											<NoSpinWinnerIcon />
											<Title>{t("spin.emptyText")}</Title>
										</EmptyTextWrapper>
									)}
									{winners.map((winner, index) => (
										<WinnerItem key={index}>
											<Number>{index + 1}.</Number>
											<LeftSection>
												<PhNameWrapper>
													<NameWrapper>{winner.name}</NameWrapper>
													<PhoneWrapper>{winner.phone}</PhoneWrapper>
												</PhNameWrapper>
											</LeftSection>
											<AmountWrapper>
												{getFormattedNumber(winner.amount)}
											</AmountWrapper>
										</WinnerItem>
									))}
								</WinnersContainer>
							</TableContainer>
							<ButtonWrapper>
								<ButtonDiv language={userPreferedLanguage} isRule={true} onClick={() => goToRule(rule)}>
									{t("spin.rule")}
								</ButtonDiv>
								<ButtonDiv language={userPreferedLanguage} onClick={goToHistory}>
									{t("spin.history")}
								</ButtonDiv>
							</ButtonWrapper>
						</BottomContainer>
					</>
				)}
			</RootContainer>
			<SpinAlert {...alert} onOk={onOk} />
			<LoginAlert />
			<CongratsModal data={congratsData} handleOk={handleOk} />
			<Alert />
		</>
	);
};

export default SpinHome;
